const checkoutTypes = {
  UPDATE_ORDER: "UPDATE_ORDER",
  CREATE_ORDER: "CREATE_ORDER",
  UPDATE_CREATE_ORDER_STATUS: "UPDATE_CREATE_ORDER_STATUS",
  SET_CREATE_ORDER_RESPONSE: "SET_CREATE_ORDER_RESPONSE",
};

export default checkoutTypes;
